import { BaseQueryFn, createApi } from "@reduxjs/toolkit/query/react";
import { AxiosError, AxiosRequestConfig } from "axios";
import $api from "./api";

const axiosBaseQuery =
  (
    { baseUrl }: { baseUrl: string } = { baseUrl: "" },
  ): BaseQueryFn<
    {
      url: string;
      method: AxiosRequestConfig["method"];
      data?: AxiosRequestConfig["data"];
      params?: AxiosRequestConfig["params"];
      headers?: AxiosRequestConfig["headers"];
    },
    unknown,
    unknown
  > =>
  async ({ url, method, data, params, headers }) => {
    try {
      const result = await $api.request({
        url: baseUrl + url,
        method,
        data,
        params,
        headers,
      });

      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError;
      console.log("err", {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      });
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

const baseUrl: string = process.env.REACT_APP_API_PATH ?? "";

export const backendApi = createApi({
  reducerPath: "/api/",
  baseQuery: axiosBaseQuery({
    baseUrl: baseUrl,
  }),
  refetchOnFocus: true,
  tagTypes: [
    "Addresses",
    "Car",
    "Category",
    "Calibration",
    "City",
    "Country",
    "Event",
    "GroupExpenses",
    "GroupOtherExpenses",
    "Investment",
    "InvestmentGroup",
    "Location",
    "LocationEvent",
    "LocationExpenses",
    "LocationOtherExpenses",
    "Machine",
    "Orders",
    "Payment",
    "PayoutInvestor",
    "Products",
    "Provider",
    "Role",
    "RestProducts",
    "RestHistoryProduct",
    "Route",
    "Service",
    "SnackAddress",
    "SnackAddressSales",
    "SnackItem",
    "RestSnackItem",
    "Space",
    "Status",
    "StoreDocument",
    "Task",
    "TaskItem",
    "VisitTaskCheck",
    "Template",
    "User",
    "Visit",
  ],
  /**
   * This api has endpoints injected in adjacent files,
   * which is why no endpoints are shown below.
   * If you want all endpoints defined in the same file, they could be included here instead
   */
  endpoints: () => ({}),
});
